import React, { useState } from "react";
import Select from "react-select";

const ApproverModal = ({ show, close, title, options, onSubmit }) => {
  const [selectedPerson, setSelectedPerson] = useState(null);

  const handleChange = (selectedOption) => {
    setSelectedPerson(selectedOption ? selectedOption.value : "");
  };

  const handleSubmit = () => {
    if (selectedPerson) {
      onSubmit(selectedPerson);
      close(); // Close modal after submitting and reset
    } else {
      alert("Please select a person");
    }
  };
  const handleClose = () => {
    setSelectedPerson(''); // Reset selected person
    close(); // Close modal and reset the state
  };
  return (
    <div
      className={`modal fade ${show ? "show" : ""}`}
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden={!show}
      style={{ display: show ? "block" : "none" }}
    >
      <div className="modal-dialog">
        <div className="modal-content" style={{ width: '70%' }}>
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose} // Use handleClose to reset and close
            ></button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="personSelect">
                Select person to send this draft for approval:
              </label>
              <Select
                id="personSelect"
                value={options.find((opt) => opt.value === selectedPerson) || null}
                onChange={handleChange}
                options={options}
                placeholder="Select a person"
                isClearable
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={handleClose}>
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={handleSubmit}>
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApproverModal;
